import styled from "styled-components";
// import Tokenomics from './Tokenomics';

const TokenomicsCss = styled.div`
  background-color: #112c31;
  text-align: center;
  .wrapper {
    text-align: center;
    font-family: Poppins;
    padding-bottom: 4rem;
    @media (max-width: 800px) {
      padding-bottom: 3rem;
    }
    .title {
      transform: translateX(-100%);
      transition: 2s ease;
      font-family: Poppins;
      font-size: 40px;
      font-style: normal;
      font-weight: 300;
      line-height: 60px;
      letter-spacing: 0em;
      text-align: center;
      color: white;
      padding-top: 2rem;
      padding-bottom: 1rem;
      &.fadeIn {
        transform: translateX(0%);
        opacity: 1;
      }
      @media (max-width: 1700px) {
        font-size: 34px;
      }
      @media (max-width: 1000px) {
        // font-size: 30px;
      }
      @media (max-width: 800px) {
        font-size: 30px;
        padding-bottom: 0;
      }
      @media (max-width: 600px) {
        font-size: 26px;
        padding-bottom: 0;
      }
    }
    .content {
      display: flex;
      @media (max-width: 800px) {
        display: none;
      }
      justify-content: space-between;
      padding: 0 15rem;
      @media (max-width: 1700px) {
        padding: 0 8rem;
      }
      @media (max-width: 1050px) {
        padding: 0 5rem;
      }
      .left {
        height: 35rem; //breakpoint
        @media (max-width: 1700px) {
          height: 28rem;
        }
        @media (max-width: 1050px) {
          height: 22rem;
        }
        margin-top: auto;
        margin-bottom: auto;
        flex: 0.2;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: right;
        .data {
          display: flex;
          justify-content: space-between;
          .text {
            padding-right: 1rem;
            flex: 0.8;
            h3 {
              color: #fdcd0b;
              font-weight: 500;
              font-size: 24px;
              line-height: 28px;
              @media (max-width: 1700px) {
                font-weight: 460;
                font-size: 20px;
                line-height: 20px;
                @media (max-width: 1000px) {
                  font-size: 16px;
                  line-height: 16px;
                }
              }
            }
            p {
              color: white;
              font-weight: 400;
              font-size: 20px;
              line-height: 24px;
              @media (max-width: 1700px) {
                font-weight: 360;
                font-size: 18px;
                line-height: 20px;
              }
              @media (max-width: 1000px) {
                font-size: 14px;
                line-height: 16px;
              }
            }
          }
          .color {
            flex: 0.15;
            text-align: left;
          }
        }
      }
      .middle {
        // width: 500px;
        flex: 0.5;
      }
      .right {
        height: 35rem;
        @media (max-width: 1700px) {
          height: 28rem;
        }
        @media (max-width: 1050px) {
          height: 22rem;
        }
        margin-top: auto;
        margin-bottom: auto;
        flex: 0.2;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: left;

        .data {
          // padding-bottom: 2rem;
          display: flex;
          .text {
            padding-left: 1rem;
            flex: 0.8;
            h3 {
              color: #fdcd0b;
              font-weight: 500;
              font-size: 24px;
              line-height: 28px;
              @media (max-width: 1700px) {
                font-weight: 460;
                font-size: 20px;
                line-height: 20px;
              }
              @media (max-width: 1000px) {
                font-size: 16px;
                line-height: 16px;
              }
            }
            p {
              color: white;
              font-weight: 400;
              font-size: 20px;
              line-height: 24px;
              @media (max-width: 1700px) {
                font-weight: 360;
                font-size: 18px;
                line-height: 20px;
              }
              @media (max-width: 1000px) {
                font-size: 14px;
                line-height: 16px;
              }
            }
          }
          .color {
            flex: 0.15;
            text-align: left;
          }
        }
      }
    }
    .bottom {
      display: flex;
      @media (max-width: 800px) {
        display: none;
      }
      // justify-content: space-between;

      justify-content: center;
      margin-left: auto;
      margin-right: auto;
      .left {
        flex: 0.5;
        border-right: 1px solid rgba(253, 205, 11, 0.4);
        .left_data {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 45%;
          margin-right: 0;
          margin-left: auto;
          padding-right: 1rem;
          h2 {
            font-family: Poppins;
            font-size: 44px;
            font-style: normal;
            font-weight: 300;
            line-height: 66px;
            letter-spacing: 0em;
            text-align: center;
            color: #fdcd0b;
            @media (max-width: 1700px) {
              font-weight: 300;
              font-size: 36px;
              line-height: 50px;
            }
            @media (max-width: 1000px) {
              font-size: 24px;
              line-height: 26px;
            }
          }
          p {
            font-family: Poppins;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 27px;
            letter-spacing: 0em;
            text-align: center;
            color: white;
            @media (max-width: 1700px) {
              font-weight: 400;
              font-size: 16px;
              line-height: 20px;
            }
            @media (max-width: 1000px) {
              font-size: 13px;
              line-height: 18px;
            }
          }
        }
      }
      .right {
        text-align: center;
        // flex: 0.5;
        .right_data {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          // width: 45%;
          margin-right: auto;
          margin-left: 0;
          padding-left: 1rem;

          h2 {
            font-family: Poppins;
            font-size: 44px;
            font-style: normal;
            font-weight: 300;
            line-height: 66px;
            letter-spacing: 0em;
            text-align: center;
            color: #fdcd0b;
            @media (max-width: 1700px) {
              font-weight: 300;
              font-size: 36px;
              line-height: 50px;
            }
            @media (max-width: 1000px) {
              font-size: 24px;
              line-height: 26px;
            }
          }
          p {
            font-family: Poppins;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 27px;
            letter-spacing: 0em;
            text-align: center;
            color: white;
            @media (max-width: 1700px) {
              font-weight: 400;
              font-size: 16px;
              line-height: 20px;
            }
            @media (max-width: 1000px) {
              font-size: 13px;
              line-height: 18px;
            }
          }
        }
      }
    }
    .content_mobile {
      display: none;
      justify-content: space-between;
      flex-direction: column;
      @media (max-width: 800px) {
        display: flex;
      }
      .top {
        width: 500px;
        height: 300px;
        margin-left: auto;
        margin-right: auto;
        paddding-bottom: 1rem;
        @media (max-width: 500px) {
          width: 300px;
          height: 200px;
        }
      }
      .middle {
        display: flex;
        justify-content: space-between;
        margin-left: auto;
        margin-right: auto;
        padding-top: 2rem;
        .left {
          flex: 0.5;
          border-right: 1px solid rgba(253, 205, 11, 0.4);
          .left_data {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            // width: 45%;
            margin-right: 0;
            // margin-left: auto;
            padding-right: 1rem;
            h2 {
              font-family: Poppins;
              font-size: 44px;
              font-style: normal;
              font-weight: 300;
              line-height: 66px;
              letter-spacing: 0em;
              text-align: center;
              color: #fdcd0b;
              @media (max-width: 800px) {
                font-size: 22px;
                line-height: 24px;
              }
            }
            p {
              font-family: Poppins;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 27px;
              letter-spacing: 0em;
              text-align: center;
              color: white;
              @media (max-width: 1000px) {
                font-size: 13px;
                line-height: 18px;
              }
            }
          }
        }
        .right {
          flex: 0.5;
          .right_data {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            // width: 45%;
            // margin-right: auto;
            margin-left: 0;
            padding-left: 1rem;

            h2 {
              font-family: Poppins;
              font-size: 44px;
              font-style: normal;
              font-weight: 300;
              line-height: 66px;
              letter-spacing: 0em;
              text-align: center;
              color: #fdcd0b;

              @media (max-width: 800px) {
                font-size: 22px;
                line-height: 24px;
              }
            }
            p {
              font-family: Poppins;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 27px;
              letter-spacing: 0em;
              text-align: center;
              color: white;
              @media (max-width: 1000px) {
                font-size: 13px;
                line-height: 18px;
              }
            }
          }
        }
      }
      .bottom_mob {
        display: flex;
        // margin-top: 2rem;
        padding: 0 1rem;
        justify-content: space-around;
        .left {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 4rem 0;
          .data {
            display: flex;
            padding: 2rem 0rem 0rem 1rem;

            .color {
              img {
                width: 10px;
              }
            }
            .text {
              padding-left: 1rem;
              text-align: left;
              h3 {
                font-family: Poppins;
                font-size: 12px;
                font-style: normal;
                font-weight: 300;
                line-height: 15px;
                letter-spacing: 0em;
                text-align: left;
                color: #fdcd0b;
              }
              p {
                font-family: Poppins;
                font-size: 12px;
                font-style: normal;
                font-weight: 300;
                line-height: 13px;
                letter-spacing: 0em;
                text-align: left;
                color: #ffffff;
              }
            }
          }
        }
        .right {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 4rem 0;
          .data {
            padding: 2rem 0rem 0rem 2rem;
            display: flex;
            .color {
              img {
                width: 10px;
              }
            }
            .text {
              padding-left: 1rem;
              text-align: left;
              h3 {
                font-family: Poppins;
                font-size: 12px;
                font-style: normal;
                font-weight: 300;
                line-height: 15px;
                letter-spacing: 0em;
                text-align: left;
                color: #fdcd0b;
              }
              p {
                font-family: Poppins;
                font-size: 12px;
                font-style: normal;
                font-weight: 300;
                line-height: 13px;
                letter-spacing: 0em;
                text-align: left;
                color: #ffffff;
              }
            }
          }
        }
      }
    }
  }
`;

export default TokenomicsCss;
